import { useContext } from 'preact/hooks';
import { ChatContext } from '../hooks/context.js';
import { suggestions } from '../store/chatStore.js';

export function QuickReplies({ items, onSend, isFloatpanel }) {
  const { bus, session } = useContext(ChatContext);
  if (!items?.length) return null;

  const handleClick = (q, idx) => {
    bus.emit('action', { action: 'suggestion', value: q, sessionId: session.getOrCreate().sessionId });
    suggestions.value = items.filter((_, i) => i !== idx);
    onSend(q);
  };

  return (
    <div
      class={`mc-chips${isFloatpanel ? ' mc-gchips' : ''}`}
      aria-label="Suggested questions"
      part="chips"
    >
      {items.map((q, i) => (
        <button
          key={q}
          class="mc-chip"
          onClick={() => handleClick(q, i)}
        >
          {q}
        </button>
      ))}
    </div>
  );
}
